export default {
  ITEM: "item"
};



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseWord/ItemTypes.js